import SellerRouter from './Seller.router';
export default SellerRouter;

export { default as sellerRouterRoutes } from './routes';
